<template>
  <div class="container1">
    <b-card-group>
      <b-card v-if="rule_sel" class="border-0">
        <vcl-facebook v-if="loading"></vcl-facebook>
        <table v-else class="table table-sm">
          <thead>
            <tr>
              <th class="fixedHeader">
                <b-form-checkbox
                  size="lg"
                  v-model="all_usage_status"
                  :indeterminate="sub_status"
                  @change="all_toggle($event)"
                  style="padding: 0 0 0 15; height: 10px; top:-10px;"
                  :disabled="rule_lock"
                >
                </b-form-checkbox>
              </th>
              <th class="fixedHeader" style="cursor:pointer" @click="ruleOpenOrCloseAll">
                <i class="fa" :class="{'fa fa-folder-open': all_open_status, 'fa fa-folder': !all_open_status }"></i>
              </th>
              <th class="fixedHeader" style="min-width:80px;">정책 ID</th>
              <th class="fixedHeader">정책명</th>
              <th class="fixedHeader" style="min-width: 120px;">탐지 / 차단</th>
              <th class="fixedHeader" style="min-width: 60px;">레벨</th>
              <th class="fixedHeader">위험도</th>
            </tr>
          </thead>
          <!-- loop policy -->
          <tbody v-for="(r, rindex) in rule_data" v-bind:key="r.id">
            <tr style="cursor:pointer">
              <!-- 룰 선택 및 사용 여부 -->
              <td class="align-middle">
                <!-- 900 은 설정으로 예외, 반드시 필요 -->
                <b-form-checkbox
                  size="lg"
                  :name="`main_policy_${r.key}`"
                  :id="`main_policy_${rindex}`"
                  :indeterminate="r.indeterminate"
                  :disabled="rule_lock"

                  v-model="r.use"
                  v-if="r.key != '900'"
                  @change="policy_toggle(rindex, -1, $event)"
                >
                </b-form-checkbox>
              </td>
              <!-- 1. 확장 또는 룰 세부 아이디 -->
              <td  class="align-middle" @click="open_toggle(rindex)">
                <b-btn variant="outline-secondary" size="sm">
                  <i class="fa" :class="{'fa fa-folder-open': r.open, 'fa fa-folder': !r.open }"></i>
                </b-btn>
              </td>

              <td scope="row" class="align-middle" @click="open_toggle(rindex)">
                {{r.key}}
                <span class="badge badge-success">{{(r.rules || []).length || 0 }}</span>
              </td>
              <td scope="row" class="align-middle" @click="!r.open && open_toggle(rindex)">
                <!-- 여기서 블럭만 혹은 탐지만 설정이 가능해야 함, 확장을 열었을 경우에만 동작 -->
                {{ r.i18n ? r.i18n['KO'] ? r.i18n['KO'] : r.i18n['KOR'] : r.desc }}
              </td>
              <td scope="row" class="align-middle" style="cursor:pointer">
                <b-badge @click="rule_mode_toggle_all(rindex)" variant="warning">{{r.detect}}</b-badge>
                <b-badge @click="rule_mode_toggle_all(rindex)" variant="danger">{{r.block}}</b-badge>
              </td>
              <td scope="row" class="align-middle" @click="policy_toggle(rindex, -1, !r.use)">
                -
              </td>
              <td scope="row" class="align-middle" @click="policy_toggle(rindex, -1, !r.use)">
                -
              </td>
            </tr>
            <tr v-for="(s, sindex) in r.rules" v-bind:key="s.id">
              <td v-if="r.open" scopre="row" class="align-msiddle text-center" colspan="2">
                <input type="checkbox" v-model="s.use" @click="policy_toggle(rindex, sindex)" :disabled="rule_lock ? rule_lock : s.level > level">
              </td>
              <td v-if="r.open" scope="row" class="align-middle" style="cursor:pointer;padding-left:2%" @click="policy_toggle(rindex, sindex)">
                <del v-if="s.level > level">{{s.key}}</del>
                <span v-else>{{s.key}}</span>
              </td>
              <td v-if="r.open" scope="row" class="align-middle" style="cursor:pointer;" @click="policy_toggle(rindex, sindex)">
                <del v-if="s.level > level">
                  {{ s.i18n ? s.i18n['KO'] ? s.i18n['KO'] : s.i18n['KOR'] : s.desc }}
                </del>
                <span v-else>
                  {{ s.i18n ? s.i18n['KO'] ? s.i18n['KO'] : s.i18n['KOR'] : s.desc }}
                </span>
              </td>
              <!-- v-b-tooltip.hover
                title="You must set the main firewall mode to operate it." -->
              <td
                v-if="r.open"
                class="align-middle"
                style="cursor:pointer;"
                @click="rule_mode_toggle(rindex, sindex)"
                :disabled="rule_lock"
              >
                <b-badge :variant="s.mode ? 'danger' : 'warning'">{{s.mode ? '차단' : '탐지'}}</b-badge>
              </td>
              <td v-if="r.open" scope="row" class="align-middle" style="cursor:pointer;">
                <b-badge v-if="s.level <= level" :variant="s.level <= level ? 'success' : ''">{{s.paranoia_level}}</b-badge>
                <b-badge v-else><s>{{s.paranoia_level}}</s></b-badge>
              </td>
              <!-- Todo : 위험도에 따른 단어 한글 번역 필요 -->
              <!-- https://www.modsecurity.org/CRS/Documentation/anomaly.html -->
              <!-- # - F1security Custom severity: Anomaly Score of 6.    For f1security custom
              # - CRITICAL severity: Anomaly Score of 5.    Mostly generated by the application attack rules (93x and 94x files).
              # - ERROR severity: Anomaly Score of 4.       Generated mostly from outbound leakage rules (95x files).
              # - WARNING severity: Anomaly Score of 3.     Generated mostly by malicious client rules (91x files).
              # - NOTICE severity: Anomaly Score of 2.      Generated mostly by the protocol rules (92x files). -->
              <td v-if="r.open" scope="row" class="align-middle" style="cursor:pointer">
                <b-badge v-if="s.severity == 'emergency'" variant="danger">{{s.severity}}</b-badge>
                <b-badge v-if="s.severity == 'critical'" variant="danger">{{s.severity}}</b-badge>
                <b-badge v-else-if="s.severity == 'error'" variant="warning">{{s.severity}}</b-badge>
                <b-badge v-else-if="s.severity == 'notice'" variant="warning">{{s.severity}}</b-badge>
                <b-badge v-else-if="s.severity == 'warning'" variant="warning">{{s.severity}}</b-badge>
                <b-badge v-else-if="s.severity == 'alert'" variant="dark">{{s.severity}}</b-badge>
                <b-badge v-else variant="secondary">{{'None'}}</b-badge>
              </td>
            </tr>
          </tbody>
          <!-- 정책 관련 정보가 없을시 -->
          <tbody v-if="!rule_data">
            <tr>
              <td colspan="7">
                현재 버전에서는 지원하지않아요.
              </td>
            </tr>
          </tbody>
        </table>
      </b-card>
      <b-card class="text-center" v-else>
        <span>
          Rule 목록을 가져오지못했습니다.
          <br>
          에이전트가 동작하고 있는지 확인해주세요.
        </span>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
